export default "__VITE_ASSET__8uhLKVYY__"